<seira-layout-padrao
	[listPathPage]="listPathPage"
	[breadcrumbElements]="breadcrumbElements">
	<div class="content d-flex justify-content-center align-items-center">
		<seira-form-alterar-senha> </seira-form-alterar-senha>
	</div>
</seira-layout-padrao>
